import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import WarningIcon from '@mui/icons-material/Warning';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import FlightListProvider from 'components/FlightListProvider';

import { FlightDetailsPrice_flight$key } from '__generated__/FlightDetailsPrice_flight.graphql';

type Props = {
  flight: FlightDetailsPrice_flight$key;
};

const FlightDetailsPrice: FC<Props> = props => {
  const flight = useFragment(
    graphql`
      fragment FlightDetailsPrice_flight on Flight {
        priceLive
        isUpdating

        lastSuccessfulUpdate {
          createdAt
        }

        ...FlightListProvider_flight
      }
    `,
    props.flight
  );

  const { priceLive, lastSuccessfulUpdate, isUpdating } = flight;

  return (
    <Box sx={{ pb: 1, height: '100%' }}>
      <Paper sx={{ height: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            p: 1,
            height: '100%',
          }}>
          <Box display="flex">
            <Box sx={{ flexGrow: 1 }}>
              {!isUpdating && (
                <Tooltip title="Skrydis neatsinaujina">
                  <WarningIcon
                    color="error"
                    fontSize="small"
                    sx={{
                      mr: 1,
                      verticalAlign: 'middle',
                      display: 'inline-block',
                    }}
                  />
                </Tooltip>
              )}
            </Box>

            <FlightListProvider flight={flight} sx={{ height: 20 }} />
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 700,
              fontSize: '1.5em',
              flexDirection: 'column',
            }}>
            €{priceLive}
            {lastSuccessfulUpdate && (
              <Typography
                sx={{
                  mt: '5px',
                  textAlign: 'center',
                }}
                variant="caption">
                Atnaujinta: {lastSuccessfulUpdate.createdAt}
              </Typography>
            )}
          </Box>

          {props.children}
        </Box>
      </Paper>
    </Box>
  );
};

export default FlightDetailsPrice;
